import { carouselCards } from '@/mocks/home';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-950 text-center mb-8">
          焦点专题
        </h2>
        <div className="flex flex-col gap-5">
          {carouselCards.map((card, i) => (
            <div
              key={i}
              className="flex flex-col md:flex-row bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-colors duration-300 cursor-pointer"
            >
              <div className="w-full md:w-[360px] lg:w-[420px] flex-shrink-0">
                <div className="relative aspect-video md:aspect-[4/3] md:h-full bg-background-200 overflow-hidden">
                  <img
                    src={card.image}
                    alt={card.title}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
              </div>
              <div className="flex-1 p-5 md:p-6 flex flex-col justify-center">
                <span className="inline-block px-2.5 py-0.5 bg-accent-100 text-accent-700 text-xs font-medium rounded-full w-fit whitespace-nowrap mb-3">
                  {card.tag}
                </span>
                <h3 className="text-base md:text-lg font-heading text-foreground-900 mb-2">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{card.desc}</p>
                <span className="inline-flex items-center gap-1 text-sm text-primary-600 font-medium mt-3 whitespace-nowrap cursor-pointer">
                  查看专题 <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}